export * from './IMoniker';
export * from './naming.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/naming/index.ts